import React from 'react';

import { useDispatch, useSelector } from "react-redux";

const PreloaderSales = () => {


    const theme = useSelector((state) => state.initData.theme);

    return (
        <>
            {theme == 'dark' && (
                <svg width="375" height="776" viewBox="0 0 375 776" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_0_115)">
                    <g filter="url(#filter0_b_0_115)">
                    <rect x="16" width="169" height="252" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    <g clip-path="url(#clip1_0_115)">
                    <g filter="url(#filter1_b_0_115)">
                    <rect x="16" y="260" width="169" height="120" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    <g clip-path="url(#clip2_0_115)">
                    <g filter="url(#filter2_b_0_115)">
                    <rect x="16" y="388" width="169" height="120" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    <g clip-path="url(#clip3_0_115)">
                    <g filter="url(#filter3_b_0_115)">
                    <rect x="16" y="516" width="169" height="252" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    <g clip-path="url(#clip4_0_115)">
                    <g clip-path="url(#clip5_0_115)">
                    <g filter="url(#filter4_b_0_115)">
                    <rect x="191.5" width="169" height="120" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    </g>
                    <g clip-path="url(#clip6_0_115)">
                    <g clip-path="url(#clip7_0_115)">
                    <g filter="url(#filter5_b_0_115)">
                    <rect x="191.5" y="128" width="169" height="252" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    </g>
                    <g clip-path="url(#clip8_0_115)">
                    <g clip-path="url(#clip9_0_115)">
                    <g filter="url(#filter6_b_0_115)">
                    <rect x="191.5" y="388" width="169" height="120" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    </g>
                    <g clip-path="url(#clip10_0_115)">
                    <g clip-path="url(#clip11_0_115)">
                    <g filter="url(#filter7_b_0_115)">
                    <rect x="191.5" y="516" width="169" height="120" rx="8" fill="#2C2C2E"/>
                    </g>
                    </g>
                    </g>
                    <g clip-path="url(#clip12_0_115)">
                    <rect x="191.5" y="644" width="169" height="120" rx="8" fill="#333333"/>
                    </g>
                    <defs>
                    <filter id="filter0_b_0_115" x="-24" y="-40" width="249" height="332" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter1_b_0_115" x="-24" y="220" width="249" height="200" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter2_b_0_115" x="-24" y="348" width="249" height="200" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter3_b_0_115" x="-24" y="476" width="249" height="332" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter4_b_0_115" x="151.5" y="-40" width="249" height="200" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter5_b_0_115" x="151.5" y="88" width="249" height="332" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter6_b_0_115" x="151.5" y="348" width="249" height="200" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <filter id="filter7_b_0_115" x="151.5" y="476" width="249" height="200" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_115"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_115" result="shape"/>
                    </filter>
                    <clipPath id="clip0_0_115">
                    <rect x="16" width="169" height="252" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip1_0_115">
                    <rect x="16" y="260" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip2_0_115">
                    <rect x="16" y="388" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip3_0_115">
                    <rect x="16" y="516" width="169" height="252" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip4_0_115">
                    <rect x="191.5" width="167.5" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip5_0_115">
                    <rect x="191.5" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip6_0_115">
                    <rect x="191.5" y="128" width="167.5" height="252" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip7_0_115">
                    <rect x="191.5" y="128" width="169" height="252" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip8_0_115">
                    <rect x="191.5" y="388" width="167.5" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip9_0_115">
                    <rect x="191.5" y="388" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip10_0_115">
                    <rect x="191.5" y="516" width="167.5" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip11_0_115">
                    <rect x="191.5" y="516" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    <clipPath id="clip12_0_115">
                    <rect x="191.5" y="644" width="169" height="120" rx="8" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>                
            ) || (
                <svg
                    width="375"
                    height="548"
                    viewBox="0 0 375 548"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_0_1140)">
                        <g clip-path="url(#clip1_0_1140)">
                            <g filter="url(#filter0_b_0_1140)">
                                <rect
                                    x="16"
                                    y="24"
                                    width="169"
                                    height="252"
                                    rx="8"
                                    fill="#E9E9EB"
                                />
                            </g>
                        </g>
                        <g clip-path="url(#clip2_0_1140)">
                            <g filter="url(#filter1_b_0_1140)">
                                <rect
                                    x="16"
                                    y="284"
                                    width="169"
                                    height="120"
                                    rx="8"
                                    fill="#E9E9EB"
                                />
                            </g>
                        </g>
                        <g clip-path="url(#clip3_0_1140)">
                            <g filter="url(#filter2_b_0_1140)">
                                <rect
                                    x="16"
                                    y="412"
                                    width="169"
                                    height="120"
                                    rx="8"
                                    fill="#E9E9EB"
                                />
                            </g>
                        </g>
                        <g clip-path="url(#clip4_0_1140)">
                            <g clip-path="url(#clip5_0_1140)">
                                <g filter="url(#filter3_b_0_1140)">
                                    <rect
                                        x="191.5"
                                        y="24"
                                        width="169"
                                        height="120"
                                        rx="8"
                                        fill="#E9E9EB"
                                    />
                                </g>
                            </g>
                        </g>
                        <g clip-path="url(#clip6_0_1140)">
                            <g clip-path="url(#clip7_0_1140)">
                                <g filter="url(#filter4_b_0_1140)">
                                    <rect
                                        x="191.5"
                                        y="152"
                                        width="169"
                                        height="252"
                                        rx="8"
                                        fill="#E9E9EB"
                                    />
                                </g>
                            </g>
                        </g>
                        <g clip-path="url(#clip8_0_1140)">
                            <g clip-path="url(#clip9_0_1140)">
                                <g filter="url(#filter5_b_0_1140)">
                                    <rect
                                        x="191.5"
                                        y="412"
                                        width="169"
                                        height="120"
                                        rx="8"
                                        fill="#E9E9EB"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <defs>
                        <filter
                            id="filter0_b_0_1140"
                            x="-24"
                            y="-16"
                            width="249"
                            height="332"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_b_0_1140"
                            x="-24"
                            y="244"
                            width="249"
                            height="200"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter2_b_0_1140"
                            x="-24"
                            y="372"
                            width="249"
                            height="200"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter3_b_0_1140"
                            x="151.5"
                            y="-16"
                            width="249"
                            height="200"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter4_b_0_1140"
                            x="151.5"
                            y="112"
                            width="249"
                            height="332"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter5_b_0_1140"
                            x="151.5"
                            y="372"
                            width="249"
                            height="200"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_0_1140"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_0_1140"
                                result="shape"
                            />
                        </filter>
                        <clipPath id="clip0_0_1140">
                            <rect width="375" height="548" rx="16" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_0_1140">
                            <rect
                                x="16"
                                y="24"
                                width="169"
                                height="252"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip2_0_1140">
                            <rect
                                x="16"
                                y="284"
                                width="169"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip3_0_1140">
                            <rect
                                x="16"
                                y="412"
                                width="169"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip4_0_1140">
                            <rect
                                x="191.5"
                                y="24"
                                width="167.5"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip5_0_1140">
                            <rect
                                x="191.5"
                                y="24"
                                width="169"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip6_0_1140">
                            <rect
                                x="191.5"
                                y="152"
                                width="167.5"
                                height="252"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip7_0_1140">
                            <rect
                                x="191.5"
                                y="152"
                                width="169"
                                height="252"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip8_0_1140">
                            <rect
                                x="191.5"
                                y="412"
                                width="167.5"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                        <clipPath id="clip9_0_1140">
                            <rect
                                x="191.5"
                                y="412"
                                width="169"
                                height="120"
                                rx="8"
                                fill="white"
                            />
                        </clipPath>
                    </defs>
                </svg>
                )}
        </>
    );
};

export default PreloaderSales;
